module.exports = __webpack_public_path__ + "static/media/google-icon.695a3160.svg";